import { Component, ElementRef, Input, Renderer2, ViewChild } from '@angular/core';
import { IonicPage, NavController, NavParams, ViewController, Platform } from 'ionic-angular';

/**
 * Generated class for the GdxModalPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'gdx-modal',
  templateUrl: 'gdx-modal.html',
})
export class GdxModalPage {
  @ViewChild('contentArea') contentArea: ElementRef;
  @ViewChild('holderArea') holderArea: ElementRef;
  @ViewChild('container') container: ElementRef;
  @ViewChild('blocked') blocked: ElementRef;

  @Input() size: any = 'normal'; // small, normal, big
  @Input() height: any; // Percent

  public holder: any;
  public panDown: any;
  public isSwipeDown: boolean = false;
  public modalWrapper: any;
  public containerWrapper: any;
  public isDragging: boolean = false;
  public posYExp: any;
  public lastPosY: any;
  public block: any;

  public scrollContent: any;
  public scrollContentTop: any = 0;
  
  public innerWidth: any;
  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public viewCtrl: ViewController,
    private platform: Platform,
    private renderer: Renderer2) {
  }

  ngOnInit() {
    // scroll or any other event
    // this.renderer.listen(this.ScrollEl, 'scroll', (event) => {
    //   console.log('brooo')
    // });
  }

  ngAfterViewInit() {
    this.holder = this.holderArea.nativeElement;
    this.modalWrapper = this.contentArea.nativeElement;
    this.block = this.blocked.nativeElement;
    this.innerWidth = window.innerWidth;
    if(window.innerWidth < 768){
      this.getScrollContent();
      this.blockTouch();
      this.panGesture();
      this.swipeGesture();
    }
  }

  getScrollContent(){
    this.containerWrapper = this.container.nativeElement.children;
    var arrCol = Array.prototype.slice.call(this.containerWrapper);  // mengubah HTMLCollection Node ke Array
    arrCol.forEach(el => {  // Mencari element ion-content
      if (el.nodeName == 'ION-CONTENT' || el.nodeName == 'ion-content') {
        this.scrollContent = el.children[1]; // Mendapatkan element scroll-content
      }
    });

    // scroll Event
    if (!this.platform.is('ios')) {
      this.renderer.listen(this.scrollContent, 'scroll', (event) => {
        // Calculating scroll to top
        this.scrollContentTop = this.scrollContent.scrollTop;
        if(this.scrollContentTop == 0){
          this.scrollContent.style.touchAction = 'pan-down';
        }else{
          this.scrollContent.style.touchAction = 'auto';
        }
      });
    }
  }

  blockTouch(){
    this.renderer.listen(this.container.nativeElement, 'touchstart', (event) => {
      // Calculating scroll to top
      // console.log('klick ',this.isDragging);
      // console.log(event);
      // console.log(event.target);
      // let target = event.target;
      // target.style.background = 'red';
      // target.style.touchAction = 'pan-down';
      // target.style.userSelect = 'none';
    });
  }

  // @HostListener('touchstart', ['$event']) onTouchStart(event: Event): void {
  //   this.ngZone.run(() => {

  //    });
  // }

  //#region : Hammer Gesture to close modal
  panGesture(){
    // PAN Gesture start
    var managerContainer = new window['Hammer'].Manager(this.container.nativeElement); // element container
    var managerHolder = new window['Hammer'].Manager(this.holder); // element holder 
    var Pan = new window['Hammer'].Pan();

    managerContainer.add(Pan);
    managerHolder.add(Pan);

    managerHolder.on('pan', (ev) => { // PAN Function untuk holder area
      if (!this.isDragging) {
        this.isDragging = true;
        this.lastPosY = 0;
      }
      this.posYExp = ev.deltaY + this.lastPosY;
      var outClose = this.modalWrapper.offsetHeight - 350;

      if (this.posYExp >= 0 && !this.isSwipeDown) {
        this.modalWrapper.style.transform = 'translateY(' + this.posYExp + 'px)';
        this.modalWrapper.style.transition = 'all 0ms';
      }

      if (ev.isFinal) { // Final or end Gesture used
        this.isDragging = false;
        if (this.posYExp > outClose && !this.isDragging) {
          this.modalWrapper.style.transform = 'translateY(100%)';
          this.modalWrapper.style.transition = 'all 200ms';
          setTimeout(() => {  // Delay to dissmiss for get transition animation timing
            this.viewCtrl.dismiss('close');
          }, 100);
        } else if (!this.isSwipeDown) {
          this.modalWrapper.style.transform = 'translateY(0px)';
          this.modalWrapper.style.transition = 'all 250ms';
        }
      }
      // console.log('pan', this.isDragging);
      // if(this.isDragging){
      //   this.blocked.nativeElement.style.pointerEvents = "auto";
      // }else{
      //   this.blocked.nativeElement.style.pointerEvents = "none";
      // }
    });

    managerContainer.on('pan', (ev) => { // PAN Function untuk container area
      this.blockTouch();
      if (!this.isDragging) {
        this.isDragging = true;
        this.lastPosY = 0;
      }
      this.posYExp = ev.deltaY + this.lastPosY;
      var outClose = this.modalWrapper.offsetHeight - 350;

      if (this.posYExp >= 0 && !this.isSwipeDown && this.scrollContentTop == 0) {
        this.modalWrapper.style.transform = 'translateY(' + this.posYExp + 'px)';
        this.modalWrapper.style.transition = 'all 0ms';
      }

      if (ev.isFinal) { // Final or end Gesture used
        this.isDragging = false;
        if (this.posYExp > outClose && !this.isDragging) {
          this.modalWrapper.style.transform = 'translateY(100%)';
          this.modalWrapper.style.transition = 'all 200ms';
          setTimeout(() => {  // Delay to dissmiss for get transition animation timing
            this.viewCtrl.dismiss('close');
          }, 100);
        } else if (!this.isSwipeDown) {
          this.modalWrapper.style.transform = 'translateY(0px)';
          this.modalWrapper.style.transition = 'all 250ms';
        }
      }
    });
  }

  swipeGesture(){
    // SWIPE Gesture start
    var managerContainer = new window['Hammer'].Manager(this.container.nativeElement); // element container
    var managerHolder = new window['Hammer'].Manager(this.holder);  // element holder 
    var Swipe = new window['Hammer'].Swipe();

    managerContainer.add(Swipe);
    managerHolder.add(Swipe);

    managerHolder.on("swipedown", (ev) => { // SWIPE Function untuk holder area
      var outClose = this.modalWrapper.offsetHeight - 350;

      if (ev.isFinal) { // Final or end Gesture used
        this.isSwipeDown = true; // Status SwipeDown set true
        if (this.posYExp <= outClose && ev.type == 'swipedown' && this.isSwipeDown) {
          this.modalWrapper.style.transform = 'translateY(100%)';
          this.modalWrapper.style.transition = 'all 250ms';
          setTimeout(() => {  // Delay to dissmiss for get transition animation timing
            this.viewCtrl.dismiss('close');
          }, 150);
        }
      }
    });

    managerContainer.on("swipedown", (ev) => { // SWIPE Function untuk container area
      var outClose = this.modalWrapper.offsetHeight - 350;

      if (ev.isFinal) { // Final or end Gesture used
        this.isSwipeDown = true; // Status SwipeDown set true
        if (this.posYExp <= outClose && ev.type == 'swipedown' && this.isSwipeDown && this.scrollContentTop == 0) {
          this.modalWrapper.style.transform = 'translateY(100%)';
          this.modalWrapper.style.transition = 'all 250ms';
          setTimeout(() => {  // Delay to dissmiss for get transition animation timing
            this.viewCtrl.dismiss('close');
          }, 150);
        }
      }
    });
    // SWIPE Gesture end
  }
  //#endregion

  close(){
    // console.log('close');
    this.viewCtrl.dismiss();
  }
}



// WEBPACK FOOTER //
// ./src/components/gdx-modal/gdx-modal.ts